import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

@Component({
    selector: 'app-customer-request-list',
    templateUrl: './customer-request-list.component.html',
    styleUrls: ['./customer-request-list.component.scss'],
    standalone: false
})
export class CustomerRequestListComponent implements OnInit {
  btn: any = "Pending"
  headingName:any =' Bookings'
  linkerRouteItems:any =[
    { name:'Home',route: '/home'},
    {name:'Account',route:'/customer-profile'},
    {name:'Bookings',route:'/customer-service-request-list-table'}
  ]
  orderList: any =[]
  count: any
  catName: any
  currentPage: any = 1;
  pageSize: any = 10;
  serviceStatus: any = 'PENDING'
  searchForm: UntypedFormGroup | any;
  today = new Date().toISOString().split('T')[0]
  notFoundData:boolean =false
  completedBookingsCount: number = 0
  pendingBookingsCount: number = 0
  constructor(public commonService: CommonService, public router: Router) { }

  ngOnInit(): void {
    this.searchFormValidation()
    this.serviceOrderList();
  }
  isDate(date){
  return date.length==10 ? true : false  
  }
  searchFormValidation() {
    this.searchForm = new UntypedFormGroup({
      fromDate: new UntypedFormControl(''),
      toDate: new UntypedFormControl('')
    });
  }
  searchFormSubmit() {
    this.notFoundData =false
    if (this.searchForm.value.fromDate || this.searchForm.value.toDate) {
      this.serviceOrderList()
    }
  }
  searchFormReset() {
    this.notFoundData =false
    if (this.searchForm.value.fromDate || this.searchForm.value.toDate) {
      this.searchForm.reset({
        fromDate: '',
        toDate: ''
      });
      this.serviceOrderList()
    }
    // else{
    //   this.getCustomerList()
    // }
  }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  isLoading:boolean =false
  serviceOrderList() {
    this.orderList =[]
    this.count = 0
      this.isLoading =true
    let data = {
      page: this.currentPage,
      limit: this.pageSize,
      fromDate: this.searchForm.value.fromDate ? new Date(this.searchForm.value.fromDate).toISOString() : '',
      toDate: this.searchForm.value.toDate ? new Date(this.searchForm.value.toDate).toISOString() : ''
      // orderType: 'SERVICE',
      // statusType: this.serviceStatus
    }
    data = this.commonService.removeEmptyKey(data)
    this.commonService.postApi('order/orderServiceList', data, 1).subscribe((res: any) => {
      this.isLoading =false
     
      if (res['responseCode'] == 200 && res.result.docs.length>0) {
        this.commonService.hideSpinner()
        this.orderList = res.result.docs;
        this.count = res.result.total
        if(this.orderList.length>0){
          this.notFoundData =false
        }
      }else{
        this.notFoundData = true
         this.orderList =[]
        this.commonService.hideSpinner()
        this.commonService.errorToast(res.responseMessage)
      }

    }, (err: any) => {
      this.notFoundData = true
      this.orderList =[]
      this.count =0
      this.isLoading =false
      if (err.responseCode == 409) {
        this.commonService.hideSpinner()
        this.commonService.errorToast(err.responseMessage)
      }
    })
  }

  isPageCall:boolean =false 
  changePageNumber(page) {
    this.isPageCall=true
    this.currentPage = page;
    this.serviceOrderList();
  }
  viewBookingHistoryDetails(item: any){

    localStorage.setItem('bookingData', JSON.stringify(item));
    this.router.navigate(['/customer-booking-details-view'],{
      state: { data: item }
    })
  }

  /**
   * Truncate address to first 2 words followed by "..."
   * @param address - The address object containing address, addressLine1, addressLine2
   * @returns Truncated address string with 2 words + "..."
   */
  getTruncatedAddress(address: any): string {
    if (!address) {
      return '--';
    }

    // Combine all address parts
    const addressParts = [
      address.address,
      address.addressLine1,
      address.addressLine2
    ].filter(part => part && part.trim());

    const fullAddress = addressParts.join(' ').trim();

    if (!fullAddress) {
      return '--';
    }

    // Split by spaces and take first 2 words
    const words = fullAddress.split(/\s+/).filter(word => word.length > 0);
    
    if (words.length <= 2) {
      return fullAddress;
    }

    // Return first 2 words + "..."
    return words.slice(0, 2).join(' ') + '...';
  }

  /**
   * Format category name to display on two lines
   * First word on first row, remaining words on second row
   * @param categoryName - The category name string
   * @returns Formatted category name with HTML line break
   */
  getFormattedCategory(categoryName: string): string {
    if (!categoryName) {
      return '--';
    }

    const trimmedName = categoryName.trim();
    if (!trimmedName) {
      return '--';
    }

    // Split by space
    const words = trimmedName.split(/\s+/).filter(word => word.length > 0);

    if (words.length === 0) {
      return '--';
    }

    if (words.length === 1) {
      return words[0];
    }

    // First word on first row, rest on second row with HTML line break
    const firstWord = words[0];
    const remainingWords = words.slice(1).join(' ');

    return `${firstWord}<br>${remainingWords}`;
  }
}  
